<template>
    <v-row>
        <v-col class="left-aside">
            <v-carousel
                :cycle="true"
                v-model="slide"
                :show-arrows="false"
                hide-delimiters
            >
                <v-carousel-item
                    v-for="(item, i) in items"
                    :key="i"
                >
                    <img :src="item.src" alt="img">
                </v-carousel-item>
            </v-carousel>
        </v-col>
        <v-col cols="4" md="4" class="right-aside">
            <v-pagination
                :length="items.length"
                :value="slide + 1"
                @input="slide = $event - 1"
            ></v-pagination>
        </v-col>
    </v-row>
</template>

<script>
export default {
  props: {
    items: Array
  },
  data: () => ({
    slide: 0
  })
}
</script>
